import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  ITabsMapperProps,
  ITabControllerProps,
  ITabsProps,
  ITabsStateRefValues,
} from '../Tabs.types';

export default withCompController<
  ITabsMapperProps,
  ITabControllerProps,
  ITabsProps,
  ITabsStateRefValues
>(({ mapperProps, stateValues, controllerUtils }) => {
  const { experiments = {} } = stateValues;

  return {
    ...mapperProps,
    setCurrentTabId: currentTabId => {
      controllerUtils.updateProps({ currentTabId });
    },
    reducedMotion: stateValues.reducedMotion,
    observeChildListChange: mapperProps.isMasterPage
      ? stateValues.observeChildListChangeMaster
      : stateValues.observeChildListChange,
    shouldFixSafariTabHeight: isExperimentOpen(
      experiments,
      'specs.thunderbolt.fixSafariTabHeight',
    ),
  };
});
